
<p-toast position="top-right"></p-toast> <!-- [(value)]="growlMessage" [life]="10000"-->

<p-dialog [showHeader]="false" [modal]="true" [closeOnEscape]="false" [closable]="false"
		  [resizable]="false" [draggable]="false" [blockScroll]="true" [(visible)]="working"
		  [style]="{'width': '50px', 'height': '50px', 'minWidth': '50px', 'minHeight': '50px'}"
		  [contentStyle]="{'margin':'0px', 'padding':'0px', 'overflow':'hidden'}"
		  appendTo="body">

	<p-progressSpinner [style]="{width: '50px', height: '50px', overflow: 'hidden'}" 
					   strokeWidth="8" fill="#EEEEEE" animationDuration=".5s">
	</p-progressSpinner>

</p-dialog>